/**
 * Colour dots on product cards (snippets/mc-grid-swatches.liquid).
 * A click or tap shows that colour's photo over the card image and points the
 * card's links at that variant, so opening the product lands on the colour
 * the shopper picked. Delegated on document so cards added later (filters,
 * pagination, recommendations) work without re-binding. Hovering a dot on
 * desktop preloads its photo so the swap is instant.
 */
(function () {
  'use strict';

  function showColour(swatch) {
    var card = swatch.closest('.grid-product');
    if (!card) return;

    card.querySelectorAll('[data-mc-swatch]').forEach(function (dot) {
      dot.setAttribute('aria-pressed', dot === swatch ? 'true' : 'false');
    });

    var url = swatch.getAttribute('data-url');
    if (url) {
      card.querySelectorAll('a.grid-product__link').forEach(function (link) {
        link.href = url;
      });
    }

    var src = swatch.getAttribute('data-image');
    var mask = card.querySelector('.grid-product__image-mask');
    if (!src || !mask) return;

    var image = mask.querySelector('.mc-swatch-image');
    if (!image) {
      image = document.createElement('img');
      image.className = 'mc-swatch-image';
      image.alt = '';
      mask.appendChild(image);
    }
    image.sizes = mask.offsetWidth + 'px';
    image.srcset = swatch.getAttribute('data-srcset') || '';
    image.src = src;
    image.alt = swatch.getAttribute('aria-label') || '';
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-mc-swatch]');
    if (!swatch) return;
    event.preventDefault();
    showColour(swatch);
  });

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('[data-mc-swatch]');
    if (!swatch || swatch.dataset.mcPreloaded) return;
    var src = swatch.getAttribute('data-image');
    if (src) new Image().src = src;
    swatch.dataset.mcPreloaded = 'true';
  });
})();
